import { type ScreenViewEvent } from '@stitch-fix/event-reporter';
import { type ComponentType } from 'react';
import { type NavProps } from '../../../../components/OnboardingVision/Nav';
import { type StepWrapperProps } from '../../../../components/OnboardingVision/StepWrapper';
import { anchor } from './flows/anchor';
import { nu } from './flows/nu';
import { chi } from './flows/chi';
import { tau } from './flows/tau';
import { type BusinessLine } from '../../../../types/definitions/vendor/graphql-schema.d';

const flowIds = ['nu', 'anchor', 'chi', 'tau'] as const;

export type FlowId = (typeof flowIds)[number];

export const defaultFlow: FlowId = 'nu';

export type StepComponentProps = ComponentType;

export type Step = {
  step: string;
  Component: ComponentType;
  bgColor?: StepWrapperProps['bgColor'];
  navBgColor?: NavProps['bgColor'];
  hideNav?: boolean;
  showNavTitle?: boolean;
  screenViewEvent: Pick<ScreenViewEvent, 'name' | 'content_id'>;
  gutter?: StepWrapperProps['gutter'];
  restrictedBusinessLines?: BusinessLine;
};

export const flows: Record<FlowId, Step[]> = {
  nu,
  anchor,
  chi,
  tau,
};
